/* global jQuery */
const $ = jQuery;

/* eslint no-unused-vars: 0 */
import 'whatwg-fetch';
import 'core-js/modules/es.array.iterator';
import 'promise-polyfill/src/polyfill';

require('intersection-observer');

import checkForSubmenu from './check-for-submenu';
import mobileMenu from './mobile-menu';
import toggleCountries from './toggle-countries';
import initCookiePopup from './cookie-popup';
import initEntryWinners from './entry-winners';
import initWebReportFilter from './filter-web-reports.js';
import initLoadMorePress from './load-more-press';
import lazyLoad from './lazy-load';
import updateBgColor from './update-bg-color';
import sectionNavigation from './section-navigation';

import 'Styles/main.scss';

$(async () => {
    // site wide
    const $sectionNavigation = $('.js-section-navigation');
    if ($sectionNavigation.length) {
        $sectionNavigation.map((i, v) => sectionNavigation(v));
    }

    const $cookiePopup = $('.js-cookie-popup');
    if ($cookiePopup.length) {
        $cookiePopup.map((i, v) => initCookiePopup(v));
    }

    const $entryWinners = $('#js-entry-winners');
    if ($entryWinners.length) {
        $entryWinners.map((i, v) => initEntryWinners(v));
    }

    const $webReports = $('#js-web-reports');
    if ($webReports.length) {
        $webReports.map((i, v) => initWebReportFilter(v));
    }

    const $press = $('#js-press');
    if ($press.length) {
        $press.map((i, v) => initLoadMorePress(v));
    }

    const $jsMobileMenu = $('.js-toggle-menu');
    if ($jsMobileMenu.length) {
        $jsMobileMenu.map((i, v) => mobileMenu(v));
    }

    const $jsToggleCountries = $('.js-toggle-countries');
    if ($jsToggleCountries.length) {
        $jsToggleCountries.map((i, v) => toggleCountries(v));
    }

    const $header = $('.header');
    if ($header.length) {
        $header.map((i, v) => checkForSubmenu(v));
    }

    const $updateBgColor = $('.js-update-bg-color');
    if ($updateBgColor.length) {
        $updateBgColor.map((i, v) => updateBgColor(v));
    }

    // dynamic imports

    const $jsScrollTo = $('.js-scroll-to');
    if ($jsScrollTo.length) {
        (async () => {
            const {
                default: initScrollTo
            } = await import(/* webpackChunkName: "scroll-to" */ './scroll-to');

            $jsScrollTo.map((i, v) => initScrollTo(v));
        })();
    }

    const $jsLoadScrollTo = $('.js-load-scroll-to');
    if ($jsLoadScrollTo.length) {
        (async () => {
            const {
                default: initLoadScrollTo
            } = await import(/* webpackChunkName: "load-scroll-to" */ './load-scroll-to');

            $jsLoadScrollTo.map((i, v) => initLoadScrollTo(v));
        })();
    }

    const $jsPlay = $('.js-play');
    if ($jsPlay.length) {
        (async () => {
            const {
                default: initVideo
            } = await import(/* webpackChunkName: "video" */ './video');

            $jsPlay.map((i, v) => initVideo(v));
        })();
    }

    const $jsSlider = $('.js-slider');
    if ($jsSlider.length) {
        (async () => {
            const {
                default: initSlider
            } = await import(/* webpackChunkName: "slider" */ './slider');

            $jsSlider.map((i, v) => initSlider(v));
        })();
    }

    const $jsSliderSmall = $('.js-slider-small');
    if ($jsSliderSmall.length) {
        (async () => {
            const {
                default: initSlider
            } = await import(/* webpackChunkName: "slider" */ './slider');

            $jsSliderSmall.map((i, v, size = 'small') => initSlider(v, size));
        })();
    }

    const $jsNewsletter = $('.js-form-newsletter');
    if ($jsNewsletter.length) {
        (async () => {
            const {
                default: newsletterSignup
            } = await import(/* webpackChunkName: "newsletter-signup" */ './newsletter-signup');

            $jsNewsletter.map((i, v) => newsletterSignup(v));
        })();
    }

    const $jsFilterEntries = $('.js-filter-entries');
    if ($jsFilterEntries.length) {
        (async () => {
            const {
                default: filterEntries
            } = await import(/* webpackChunkName: "filter-entries" */ './filter-entries');

            $jsFilterEntries.map((i, v) => filterEntries(v));
        })();
    }

    const $accordion = $('.js-accordion');
    if ($accordion.length) {
        (async () => {
            const {
                default: accordion
            } = await import(/* webpackChunkName: "accordion" */ './accordion');

            $accordion.map((i, v) => accordion(v));
        })();
    }

    const $toc = $('.js-toc');
    if ($toc.length) {
        (async () => {
            const {
                default: stickyToc
            } = await import(/* webpackChunkName: "sticky-toc" */ './sticky-toc');

            $toc.map((i, v) => stickyToc(v));
        })();
    }

    const $parallaxImages = $('.js-parallax-image');
    if($parallaxImages.length) {
        (async () => {
            const {
                default: parallaxImage
            } = await import(/* webpackChunkName: "parallax-image" */ './parallax-image');

            $parallaxImages.map((i, v) => parallaxImage(v));
        })();
    }

    const $scrolledIntoViewEls = $('[data-scrolled-into-view-class]');
    if ($scrolledIntoViewEls.length) {
        (async () => {
            const {
                default: scrolledIntoView
            } = await import(/* webpackChunkName: "scrolled-into-view" */ './scrolled-into-view');

            $scrolledIntoViewEls.map((i, v) => scrolledIntoView(v));
        })();
    }

    const $archiveContainer = $('#js-archive');
    if($archiveContainer.length) {
        (async () => {
            const {
                React,
                ReactDOM,
                Archive
            } = await import(/* webpackChunkName: "archive" */ '../components');

            $archiveContainer.map((i, el) => {
                const props = $(el).data('react-props');
                ReactDOM.render(
                    React.createElement(Archive, props),
                    el
                );
            });
        })();
    }

    const $entriesContainer = $('#js-entries-archive');
    if($entriesContainer.length) {
        (async () => {
            const {
                React,
                ReactDOM,
                EntriesArchive
            } = await import(/* webpackChunkName: "entriesarchive" */ '../components');

            $entriesContainer.map((i, el) => {
                const props = $(el).data('react-props');
                ReactDOM.render(
                    React.createElement(EntriesArchive, props),
                    el
                );
            });
        })();
    }

    const $tabbedTeasersEls = $('.js-tabbed-teasers');
    if ($tabbedTeasersEls.length) {
        (async () => {
            const {
                default: tabbedTeasers
            } = await import(/* webpackChunkName: "tabbed-teasers" */ './tabbed-teasers');
            $tabbedTeasersEls.map((i, v) => tabbedTeasers(v));
        })();
    }

    const $entryListEls = $('.js-entry-list');
    if ($entryListEls.length) {
        (async () => {
            const {
                default: entryList
            } = await import(/* webpackChunkName: "entry-list" */ './entry-list');
            $entryListEls.map((i, v) => entryList(v));
        })();
    }

    const $planetaryBoundaries = $('.js-planetary-boundaries');
    if ($planetaryBoundaries.length) {
        (async () => {
            const {
                default: planetaryBoundaries
            } = await import(/* webpackChunkName: "planetary-boundaries" */ './planetary-boundaries');
            $planetaryBoundaries.map((i, v) => planetaryBoundaries(v));
        })();
    }

    // global

    lazyLoad();
});
